import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { Button,Modal,ModalHeader } from 'reactstrap';
import Table from 'react-bootstrap/Table';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';

export default function Users() {
    const [search, setSearch] = useState('')
    const [users, setUsers] = useState([])
    const navigate = useNavigate();
    const [type,setType] = useState('')
    const [account, setAccount] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [modal, setModal] = useState(false);
    const [files, setFiles] = useState([]);
    const [selectedUser, setSelecteduser] = useState('')

    useEffect(() => {
        const user = localStorage.getItem('email'); // Retrieve email
        if (user) {
          setAccount(user)
        } else {
       
        }
      }, []);

      useEffect(()=>{

        const getType =async()=>{
            const res = await fetch(`https://panel.yunshuglobal.com:3063/api/getType?email=${account}`);
            const data = await res.json();
            setType(data.IsAdmin)
        }

        if(account){
            getType()
        }

      },[account])

    const toNew =()=>{
        navigate('/new-claim')
    }
    const toReport =()=>{
        navigate('/report')
    }
    const toIndividual =()=>{
        navigate('/individual-report')
    }
    
    const toHome=()=>{
        navigate('/dashboard')
      }
    const logout=()=>{
        localStorage.removeItem('email');
        navigate('/login')
      }
      const toggleMenu = () => {
        setIsOpen(!isOpen);
      };

    useEffect(()=>{
        const fetchUsers =async()=>{
            const res = await fetch('https://panel.yunshuglobal.com:3063/api/getAllusers');
            const data = await res.json();
            setUsers(data);
        }

        fetchUsers();
    },[])

    useEffect(()=>{
        const searchUsers =async()=>{
            const res = await fetch(`https://panel.yunshuglobal.com:3063/api/searchUsers?user=${search}`);
            const data = await res.json();
            setUsers(data);
        }

        if(search){
            searchUsers();

        }

        
    },[search])

    const exportToPdf = () => {
        const doc = new jsPDF();
    
        // Add a title to the PDF
        doc.text("MOTOR CLAIMS USERS REPORT", 20, 10);
    
        // Extract table headers and rows from the DOM
        const table = document.getElementById("dataTable");
        const headers = Array.from(
          table.querySelectorAll("thead tr th")
        ).map((header) => header.textContent);
    
        const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
          Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
        );
    
        // Generate the PDF table
        doc.autoTable({
          head: [headers],
          body: rows,
          startY: 20,
        });
    
        // Save the PDF
        doc.save("MOTOR_CLAIMS_USERS.pdf");
      };

      const toggle=async(e)=>{
        const email = e.target.value;
      
        setSelecteduser(email)
        const response = await fetch(`https://panel.yunshuglobal.com:3063/api/files/${email}`);
        const data = await response.json();
        setFiles(data.files);
        setModal(!modal)


      }

              const exportToExcel = () => {
        // Get the table element
        const table = document.getElementById("dataTable");
        
        // Extract headers
        const headers = Array.from(table.querySelectorAll("thead tr th")).map(
          (header) => header.textContent
        );
      
        // Extract rows
        const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
          Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
        );
      
        // Create a workbook
        const wb = XLSX.utils.book_new();
        
        // Convert data to worksheet
        const wsData = [headers, ...rows];
        const ws = XLSX.utils.aoa_to_sheet(wsData);
      
        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, "Motor Claims Report");
      
        // Generate and save the Excel file
        XLSX.writeFile(wb, "MOTOR_CLAIMS_REPORT.xlsx");
      };
    
  return (
    <div>
    <div className="homeTop">
        <ToastContainer />
        <div className="menuBar">
            <h4 className='menuTitle'>Motor Claims Database</h4>

            {type == '0' &&
                <div className="menuList">
          
                    <p className='menu'>My Claims</p>
                    <p className='menu' onClick={toNew}>New Claim</p>
                    <p className='menu' onClick={toReport}>Reports</p>
                    <p className='menu' onClick={logout}>Sign Out</p>
                    
                </div>
            
            }
            {type == '1' &&
                <div className="menuList">
          
                    <p className='menu' onClick={toHome}>My Claims</p>
                    <p className='menu'>Users</p>
                    <p className='menu' onClick={toIndividual}>Individual Reports</p>
                    <p className='menu' onClick={toReport}>Reports</p>
                    <p className='menu' onClick={logout}>Sign Out</p>
                    
                </div>
            
            }
            
            
            <div className="phoneMenu">
                <header className='header'>
                    <div className="menu-icon" onClick={toggleMenu}>
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                    </div>

                    <nav className={`nav-menu ${isOpen ? 'open' : ''}`}>
                    <ul>
                        <li ><a href="/">My Claims</a></li>
                        <li onClick={toNew}><a>New Claim</a></li>
                        <li  onClick={toReport}><a>Reports</a></li>
                        <li onClick={logout}><a>Sign Out</a></li>
                    </ul>
                    </nav>
                </header>
            </div>
        </div>
        <div className="searchContainer">
            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Search" onChange={(e)=>{setSearch(e.target.value)}}>
                <Form.Control  className='inputSearch' value={search}  type="text" placeholder="Search" />
            </FloatingLabel>
            

        </div>

        <div className="paymentDetails">
        <div className="mpesaDetails">
            <img src="/mpesa.webp" alt=""  className='mpesaLogo'/>
            <p >PAYBILL: 247 247</p>
            <p>Account No: 667899</p>
            <hr />
            <p>Individual Owner: Kes. 20,000 /=</p>
         


            </div>
        </div>
     

    </div>
    <div className="homeContainer">
            {type== '0' &&
            <div className="newClaim">
            
                <Button color='success' onClick={toNew}>Register new claim</Button>
           
            </div>
            
            }
        
        <hr />
        <h6 style={{marginTop:'1%'}}>All users({users.length})</h6>
        <Button color='success' onClick={exportToExcel} style={{marginBottom:'1%'}}>Export to CSV</Button>
       
            <div className="table-responsive">
            <Table striped bordered hover id="dataTable">

                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Identification</th>
                        <th scope="col">Date Created</th>
                        

                     
                    </tr>
                </thead>
                <tbody>
                    {users.map((val,index)=>{
                        const policyDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.CreatedAt)
                       
                        return(
                            <tr>
                                <td>{index+1}</td>
                                <td><button onClick={toggle} style={{backgroundColor:'#ffffff00',border:'none',padding:'0px'}} value={val.Email}>{val.FirstName} {val.Surname}</button></td>
                                <td><button  className='tableButton'  >{val.Email}</button></td>
                                <td>{val.Phone}</td>
                           
                                <td>{val.IDNumber}</td>
                                <td>{policyDate}</td>
                                
                               
                                

                            </tr>
                        )
                    })}
                </tbody>
            </Table>
            <div className="mobilePayment">
            <div className="mpesaDetails">
            <img src="/mpesa.webp" alt=""  className='mpesaLogo'/>
            <p >PAYBILL: 247 247</p>
            <p>Account No: 667899</p>
            <hr />
            <p>Individual Owner: Kes. 20,000 /=</p>
     


            </div>

            </div>
           
        </div>
               
        

    </div>
    

    <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader>Documents</ModalHeader>
        <div className="modalContainer">
    
            

                {files.length !== 0 &&
                 files.map((file, index) => (
                    <p key={index}>
                        <a href={`https://panel.yunshuglobal.com:3063/uploads4/${selectedUser}/${file}`} target="_blank" rel="noopener noreferrer">
                            {file}
                        </a>
                    </p>
                ))
                }

                {files.length == 0 &&
                
                <p>NO DOUMENTS FOUND</p>
                }
                
                <p style={{float:'right',color:'red',cursor:'pointer'}} onClick={()=>{setModal(false)}}>Close</p>
        </div>
    </Modal>
    
</div>
  )
}
